import { render } from "./2point-depth.vue?vue&type=template&id=d2a39ef2&ts=true"
import script from "./2point-depth.vue?vue&type=script&lang=ts"
export * from "./2point-depth.vue?vue&type=script&lang=ts"

import "./2point-depth.vue?vue&type=style&index=0&id=d2a39ef2&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__